import { cn } from "@/lib/utils";

interface CollapsibleProps {
  open: boolean;
  children: React.ReactNode;
  className?: string;
}

export const Collapsible = ({
  open,
  children,
  className,
}: CollapsibleProps) => {
  return (
    <div
      className={cn(
        "grid transition-[grid-template-rows,opacity] duration-300 ease-in-out",
        open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0",
        className,
      )}
    >
      {/* overflow-clip clips the collapsing content like overflow-hidden but
          doesn't create a scroll container, so position:sticky descendants
          keep sticking to an outer scroller (e.g. the mobile compare view).
          Unlike hidden it also doesn't zero the automatic minimum size, so
          min-h-0 is needed for the 0fr row to actually collapse, and min-w-0
          so a sideways-scrolling child scrolls instead of widening the cell
          (and with it the page). */}
      <div className="min-h-0 min-w-0 overflow-clip">{children}</div>
    </div>
  );
};
